import React from 'react';

import "./EventUser.scss";
import { Img } from '../../../../../elements/Img/Img';
import { ImgStore } from '../../../../../elements/ImgStore/ImgStore';
import { Locale } from '../../../../../assets/Locale';
import { sayEventSignStatus } from '../../../eventSay';

export const EventUser = (props)=>{
    const { status, crewId, sysUser } = props;
    const { alias, avatar } = (sysUser || {});
    const say = Locale.use();
    
    return (
        <div className="EventUser">
            <div className="avatar">{ avatar ? <Img src={avatar}/> : <ImgStore src="userAvatarDefault.webp"/> }</div>
            <div className="member"><span className="crewId">#{crewId}</span><span className="alias">{alias || "anonym"}</span></div>
            <div className="status">{sayEventSignStatus(say, status)}</div>
        </div>
    )
}

